import type { DashboardPeriodState } from "@/features/dashboard/period";

export interface DashboardPeriodAttempt {
  id: number;
  period: DashboardPeriodState;
}

export interface DashboardPeriodTransitionState {
  activePeriod: DashboardPeriodState | null;
  pending: DashboardPeriodAttempt | null;
  failed: DashboardPeriodAttempt | null;
}

export type DashboardPeriodTransitionAction =
  | { type: "request"; attempt: DashboardPeriodAttempt }
  | { type: "commit"; attempt: DashboardPeriodAttempt }
  | { type: "reject"; attempt: DashboardPeriodAttempt }
  | { type: "dismiss" };

export const initialDashboardPeriodTransition = (
  initialAttempt: DashboardPeriodAttempt,
): DashboardPeriodTransitionState => ({
  activePeriod: null,
  pending: initialAttempt,
  failed: null,
});

export const dashboardPeriodTransition = (
  state: DashboardPeriodTransitionState,
  action: DashboardPeriodTransitionAction,
): DashboardPeriodTransitionState => {
  if (action.type === "request") {
    return { ...state, pending: action.attempt, failed: null };
  }
  if (action.type === "commit") {
    if (state.pending?.id !== action.attempt.id) return state;
    return {
      activePeriod: action.attempt.period,
      pending: null,
      failed: null,
    };
  }
  if (action.type === "reject") {
    if (state.pending?.id !== action.attempt.id) return state;
    return {
      activePeriod: state.activePeriod,
      pending: null,
      failed: action.attempt,
    };
  }
  return state.failed === null ? state : { ...state, failed: null };
};
